import {TileSetPointConversion, TileSetPointDecimal, TileSetPointIncrement, TileSetPointMultiplier} from './set-point';
import {TileIcon} from './tile-icon';
import {TileDimensions} from "./tile-dimensions";

export type ColorOption =
  '' |
  'alt' |
  'alt-white' |
  'green' |
  'green-white' |
  'green-black' |
  'black-white' |
  'indigo' |
  'indigo-black' |
  'indigo-white' |
  'yellow' |
  'red';

/**
 * Alarm color constants used for critical and warning conditions.
 * These are part of the ColorOption type but separated as constants for consistency.
 *
 * Note: Using constants instead of enum to maintain type compatibility with ColorOption.
 * This allows alarm colors to be assigned directly to ColorOption-typed properties without casting.
 * TODO: Consider refactoring ColorOption from string union to enum in the future.
 */
export const ALARM_COLOR_CRITICAL: ColorOption = 'red';
export const ALARM_COLOR_WARNING: ColorOption = 'yellow';

export type TileTemplate = '' | 'set-point';

export const TILE_APPEARANCE_DEFAULT_DECIMAL: TileSetPointDecimal = 2;
export const TILE_APPEARANCE_DEFAULT_INCREMENT: TileSetPointIncrement = 1;
export const TILE_APPEARANCE_DEFAULT_MULTIPLIER: TileSetPointMultiplier = 1;

export interface Appearance {
  Icon: TileIcon;
  Color: ColorOption;
  Template?: TileTemplate;
  Config?: AppearanceConfig;
  Tags?: AppearanceTags;
  DisplayName?: string;
  Dimensions?: TileDimensions;
}

export interface AppearanceConfig {
  Increment?: TileSetPointIncrement;
  Decimal?: TileSetPointDecimal;
  Conversion?: TileSetPointConversion;
  Multiplier?: TileSetPointMultiplier;
  Offset?: number;
  MinAllowed?: null | number; // be careful; 0 is falsy but could be an intended value
  MaxAllowed?: null | number; // be careful; 0 is falsy but could be an intended value
}

export interface AppearanceTags {
  Order: string[];
}
